// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__iuqC7","containerCards":"styles_containerCards__aqxC7"};